import { swellchain as viemSwellchain } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const swellchain = {
  displayName: 'Swell',
  runtime: 'evm',
  viemChain: viemSwellchain,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'swellchain' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
